/**
 * @since 0.2.0
 */
export var CalendarChooserDisplayStyle;
(function (CalendarChooserDisplayStyle) {
    /**
     * @since 0.2.0
     */
    CalendarChooserDisplayStyle[CalendarChooserDisplayStyle["ALL_CALENDARS"] = 0] = "ALL_CALENDARS";
    /**
     * @since 0.2.0
     */
    CalendarChooserDisplayStyle[CalendarChooserDisplayStyle["WRITABLE_CALENDARS_ONLY"] = 1] = "WRITABLE_CALENDARS_ONLY";
})(CalendarChooserDisplayStyle || (CalendarChooserDisplayStyle = {}));
//# sourceMappingURL=calendar-chooser-display-style.js.map